<script setup>
import BackToTopButton from '@/Components/BackToTopButton.vue';
import { onMounted, ref, computed, defineAsyncComponent } from 'vue';
import { THEMES } from '@/constants';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

const Header = computed(
  () => defineAsyncComponent(() => import(`./../Components/Navigation/${theme}/Header.vue`))
);

const Footer = computed(
  () => defineAsyncComponent(() => import(`./../Components/Navigation/${theme}/Footer.vue`))
);

const wrapperClasses = computed(() => [
  'w-full mx-auto',
  theme == THEMES.STUDY_MELB && 'bg-white max-w-[1440px]',
]);

const mainClasses = computed(() => [
  'w-full px-3 max-w-screen-md mx-auto',
  theme == THEMES.STUDY_MELB && 'pb-10',
]);

const mainContentClasses = computed(() => [
  'hero py-16 mb-6',
  theme == THEMES.STUDY_AUS && 'bg-grey-200',
  theme == THEMES.STUDY_MELB && 'bg-primary max-w-[1440px]',
  theme == THEMES.STUDY_QLD && 'mt-[84px] min-[1200px]:mt-[146px] bg-primary-100',
]);

// backtotop button causes window not defined
// dont mount til mounted so doesnt throw error
const loading = ref(true);
onMounted(() => {
  loading.value = false;
})
</script>
<template>
  <component :is="Header" />

  <main id="main-content" tabindex="-1" aria-label="Search widget" :class="wrapperClasses">
    <div :class="mainContentClasses">
      <slot name="hero" />
    </div>
    <div :class="mainClasses">
      <slot name="content" />
    </div>
  </main>

  <footer id="footer-content" tabindex="-1">
    <BackToTopButton v-if="!loading"></BackToTopButton>
    <component :is="Footer" />
  </footer>
</template>
